import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/theme-reset.ejs';
import eventBus from 'EventBus.js';
import pageSyncService from 'PageSyncService.js';
import listService from 'ListService.js';
import constants from 'Constants.js';
import Immutable  from 'immutable';

class StyleTextView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #themeReset': 'clickResetTheme'
        }

        return this;
    }


    clickResetTheme(ev) {
        ev.preventDefault();
        if (listService.selectedCount > 1) {
            listService.selected.map(view=>{
                this.model = view.model;
                const control = this.model.get('factoryKey');
                this.triggerThemeEvent(control);
            });
        } else {
            const control = this.model.get('factoryKey');
            this.triggerThemeEvent(control);    
        }
    }

    triggerThemeEvent(control) {
        switch (control) {
            case 'page_instance':
            case 'layout_page':
            case 'report_page':
                this.resetPage();
                break;
            case 'control_text':
            case 'control_bullet_text':
                this.resetText();
                break;
            case 'control_small_text':
                this.resetSmallText();
                break;
            case 'control_large_heading':
                this.resetLargeHeading();
                break;
            case 'control_medium_heading':
                this.resetMediumHeading();
                break;
            case 'control_small_heading':
                this.resetSmallHeading();
                break;
            case 'control_link':
                this.resetLink();
                break;
            case 'control_text_input':
            case 'control_multiple_text_input':
            case 'control_numeric_input':
            case 'control_date_input':
            case 'control_time_input':
            case 'control_date_calendar':
            case 'control_list':
            case 'control_drop_down':
            case 'control_numeric_stepper':
            case 'control_mask_text_input':
            case 'control_password_input':
            case 'control_ranking':
                this.resetInputs(control);
                break;
            case 'control_file_attachment':
                this.resetFileAttachment();
                break;
            case 'control_button':
            case 'control_print_button':
            case 'control_page_button':
            case 'control_submit_button':
            case 'control_play_form_button':
            case 'control_play_report_button':
                this.resetButtons();
                break;
            case 'control_image_input':
                this.resetImageImport();
                break;
            case 'control_websignature':
                this.resetWebSignature();
                break;
            case 'control_checkbox':
            case 'control_radio_button':
                this.resetCheckboxes();
                break;
            case 'control_group':
            case 'control_section':
                this.resetGroups();
                break;
            case 'control_checkbox_group':
            case 'control_radio_button_group':
                this.resetGroupCheckboxes();
                this.resetGroups();
                break;
            case 'control_horizontal_separator':
            case 'control_vertical_separator':
                this.resetSeparators(control);
                break;
            case 'control_table':
                this.resetTables();
                break;
            default: break;
        }
    }

    resetPage() {
        this.model.set('stylePictureSelect', '~pageBgImage');
        this.model.set('styleBGColor', '~pageBgColor');
        this.model.set('styleBGColorText', '~pageBgColor');

        this.model.set('backgroundImageAssetId', '~pageBgImage');
        this.model.set('backgroundColor', '~pageBgColor');
        pageSyncService.renderCurrentPageView();
    }

    resetText() {
        this.model.set('styleColorText', '~textColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~textFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~textFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~textFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~textFont', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_17, constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetSmallText() {
        this.model.set('styleColorText', '~smallTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~smallTextFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~smallTextFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~smallTextFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~smallTextFont', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_15, constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetLargeHeading() {
        this.model.set('styleColorText', '~largeHeadingTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~largeHeadingFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~largeHeadingFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~largeHeadingFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~largeHeadingFont', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_29, constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetMediumHeading() {
        this.model.set('styleColorText', '~mediumHeadingTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~mediumHeadingFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~mediumHeadingFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~mediumHeadingFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~mediumHeadingFont', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_27, constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetSmallHeading() {
        this.model.set('styleColorText', '~smallHeadingTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~smallHeadingFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~smallHeadingFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~smallHeadingFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~smallHeadingFont', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_22, constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetLink() {
        this.model.set('styleColorText', '~linkTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~linkFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~linkFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~linkFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~linkFont', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_18, constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetInputs(control) {
        this.model.set('styleColorText', '~inputTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~inputFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~inputFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~inputFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~inputFont', constants.MODEL_SILENT);
        this.model.set('borderStyle', '~inputBorder', constants.MODEL_SILENT);
        this.model.set('borderSize', '~inputBorder', constants.MODEL_SILENT);
        this.model.set('borderColor', '~inputBorderColor', constants.MODEL_SILENT);
        this.model.set('backgroundColor', '~inputBgColor', constants.MODEL_SILENT);

        //PF-6229 For date input or drop downs the corner radius should not be taken from the theme
        if(control !== 'control_date_input' && control !== 'control_drop_down'){
            this.model.set('cornerRadius', '~inputBorder', constants.MODEL_SILENT);
        }

        let minHeight = constants.CONTROL_MIN_HEIGHT_22;
        if (control === 'control_multiple_text_input') {
            minHeight = constants.CONTROL_MIN_HEIGHT_16;
        }
        this.model.set('minHeight', minHeight, constants.MODEL_SILENT);


        this.model.trigger('change');
    }

    resetFileAttachment() {
        this.model.set('styleColorText', '~inputTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~inputFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~inputFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~inputFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~inputFont', constants.MODEL_SILENT);
        this.model.set('backgroundColor', '~inputBgColor', constants.MODEL_SILENT);
        this.model.set('borderColor', '~buttonBorderColor', constants.MODEL_SILENT);
        this.model.set('advancedBgColor', '~buttonBgColor', constants.MODEL_SILENT);
        this.model.set('backgroundFromText', '~buttonBgColor', constants.MODEL_SILENT);
        this.model.set('advancedBgGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.set('backgroundToText', '~buttonBgGradientColor', constants.MODEL_SILENT);
        // Button Styles
        this.model.set('buttonStyleColorText', '~buttonTextColor', constants.MODEL_SILENT);
        this.model.set('buttonFontFamily', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonFontSize', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonTextWeight', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonTextStyle', '~buttonFont', constants.MODEL_SILENT);

        this.model.set('buttonTextColor','~buttonTextColor', constants.MODEL_SILENT);
        this.model.set('buttonBackgroundColor', '~buttonBgColor', constants.MODEL_SILENT);
        this.model.set('buttonBackgroundGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.set('styleBGColorText' , '~inputBgColor', constants.MODEL_SILENT);

        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_25, constants.MODEL_SILENT);

        this.model.trigger('change');
    }

    resetButtons() {
        this.model.set('buttonStyle', '~buttonStyle', constants.MODEL_SILENT);
        this.model.set('styleColorText', '~buttonTextColor', constants.MODEL_SILENT);
        this.model.set('styleColorTextDown', '~buttonTextDownColor', constants.MODEL_SILENT);
        this.model.set('styleColorTextOver', '~buttonTextOverColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('cornerRadius', '~buttonRadius', constants.MODEL_SILENT);
        this.model.set('borderColor', '~buttonBorderColor', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_17, constants.MODEL_SILENT);
        this.model.set('advancedBgColor', '~buttonBgColor', constants.MODEL_SILENT);
        this.model.set('backgroundColor', '~buttonBgColor', constants.MODEL_SILENT);
        this.model.set('advancedBgGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.set('advancedBgColorOver', '~buttonBgOverColor', constants.MODEL_SILENT);
        this.model.set('advancedBgGradientColorOver', '~buttonBgGradientOverColor', constants.MODEL_SILENT);
        this.model.set('advancedBgColorDown', '~buttonBgDownColor', constants.MODEL_SILENT);
        this.model.set('advancedBgGradientColorDown', '~buttonBgGradientDownColor', constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetWebSignature() {
        this.model.set('buttonTextColor', '~buttonTextColor', constants.MODEL_SILENT);
        this.model.set('styleColorTextDown', '~buttonTextDownColor', constants.MODEL_SILENT);
        this.model.set('styleColorTextOver', '~buttonTextOverColor', constants.MODEL_SILENT);
        this.model.set('buttonFontFamily', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonFontSize', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonTextWeight', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonTextStyle', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonBackgroundColor', '~buttonBgColor', constants.MODEL_SILENT);
        this.model.set('buttonBackgroundGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.set('backgroundColor', '~inputBgColor', constants.MODEL_SILENT);
        this.model.set('advancedBgGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.set('bgGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetImageImport() {
        this.model.set('styleColorText', '~inputTextColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~inputFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~inputFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~inputFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~inputFont', constants.MODEL_SILENT);
        this.model.set('buttonTextColor', '~buttonTextColor', constants.MODEL_SILENT);
        this.model.set('buttonFontFamily', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonFontSize', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonTextWeight', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonTextStyle ', '~buttonFont', constants.MODEL_SILENT);
        this.model.set('buttonBackgroundColor', '~buttonBgColor', constants.MODEL_SILENT);
        this.model.set('buttonBackgroundGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.set('backgroundColor', '~inputBgColor', constants.MODEL_SILENT);
        this.model.set('advancedBgGradientColor', '~buttonBgGradientColor', constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetCheckboxes() {
        this.model.set('styleColorText', '~selectionTextColor', constants.MODEL_SILENT);
        this.model.set('styleColorTextOver', '~selectionTextOverColor', constants.MODEL_SILENT);
        this.model.set('fontFamily', '~selectionFont', constants.MODEL_SILENT);
        this.model.set('fontSize', '~selectionFont', constants.MODEL_SILENT);
        this.model.set('textWeight', '~selectionFont', constants.MODEL_SILENT);
        this.model.set('textStyle', '~selectionFont', constants.MODEL_SILENT);
        this.model.set('borderColor', '~selectionBorderColor', constants.MODEL_SILENT);
        this.model.set('advancedBgColor', '~selectionBgColor', constants.MODEL_SILENT);
        this.model.set('advancedBgGradientColor', '~selectionBgGradientColor', constants.MODEL_SILENT);
        this.model.set('minHeight', constants.CONTROL_MIN_HEIGHT_18, constants.MODEL_SILENT);
        this.model.set('backgroundColor', '~selectionBgGradientColor', constants.MODEL_SILENT);
        this.model.set('transparentBackground', '~checkBgTransparent', constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    resetGroupCheckboxes() {
        try {
            Immutable.List(this.model.get('childList')).map(v => {
                v.set('styleColorText', '~selectionTextColor', constants.MODEL_SILENT);
                v.set('styleColorTextOver', '~selectionTextOverColor', constants.MODEL_SILENT);
                v.set('fontFamily', '~selectionFont', constants.MODEL_SILENT);
                v.set('fontSize', '~selectionFont', constants.MODEL_SILENT);
                v.set('textWeight', '~selectionFont', constants.MODEL_SILENT);
                v.set('textStyle', '~selectionFont', constants.MODEL_SILENT);
                v.set('borderColor', '~groupBorderColor', constants.MODEL_SILENT);
                v.set('advancedBgGradientColor', '~groupBgGradientColor', constants.MODEL_SILENT);
                v.set('minHeight', constants.CONTROL_MIN_HEIGHT_17, constants.MODEL_SILENT);
                v.set('transparentBackground', '~checkBgTransparent', constants.MODEL_SILENT);

            });
            this.model.trigger('change');
        } catch (e) {
            console.log(e);
        }
    }

    resetGroups() {
        this.model.set({'titleColor': '~groupTextColor', 'titleFontFamily': '~groupFont', 'titleFontSize': '~groupFont',
            'titleTextWeight': '~groupFont',
            'titleTextStyle': '~groupFont',
            'titleBackgroundColor': '~groupTitleBg',
            'backgroundColor': '~groupBgColor',
            'backgroundImageAssetId': '~groupBgImage',
            'borderStyle': '~groupBorder',
            'borderSize': '~groupBorder',
            'cornerRadius': '~groupBorder',
            'borderColor': '~groupBorderColor',
            'styleBGColorText': '~groupBgColor',
            'bgImage': '~groupBgImage',
            'transparentBackground': '~groupBgTransparent'}, constants.MODEL_SILENT);
            this.model.trigger('change');
    }

    resetSeparators(control) {
        this.model.set('lineColor', '~seperatorColor', constants.MODEL_SILENT);
        if (control === 'control_vertical_separator') {
            this.model.set('width', '~seperatorSize', constants.MODEL_SILENT);
        } else {
            this.model.set('height', '~seperatorSize', constants.MODEL_SILENT);
        }
        this.model.trigger('change');
    }

    resetTables() {
        this.model.set('styleHeaderColorText', '~tableHeaderTextColor', constants.MODEL_SILENT);
        this.model.set('headerBgColor', '~tableHeaderBgColor', constants.MODEL_SILENT);
        this.model.set('headerBgColorGradient', '~tableHeaderBgGradientColor', constants.MODEL_SILENT);
        this.model.set('rowBGColor', '~tableRowColor1', constants.MODEL_SILENT);
        this.model.set('rowBGColorGradient', '~tableRowColor2', constants.MODEL_SILENT);
        this.model.set('backgroundColor', '~tableBgColor', constants.MODEL_SILENT);
        this.model.set('headerTextColor', '~tableHeaderTextColor', constants.MODEL_SILENT);
        this.model.set('headerFont', '~tableHeaderFont', constants.MODEL_SILENT);
        this.model.set('headerFontFamily', '~tableHeaderFont', constants.MODEL_SILENT);
        this.model.set('headerFontSize', '~tableHeaderFont', constants.MODEL_SILENT);
        this.model.set('headerTextWeight', '~tableHeaderFont', constants.MODEL_SILENT);
        this.model.set('headerTextStyle', '~tableHeaderFont', constants.MODEL_SILENT);
        this.model.set('borderSize', '~tableBorder', constants.MODEL_SILENT);
        this.model.set('borderStyle', '~tableBorder', constants.MODEL_SILENT);
        this.model.set('cornerRadius', '~tableBorder', constants.MODEL_SILENT);
        this.model.set('borderColor', '~tableBorderColor', constants.MODEL_SILENT);
        this.model.trigger('change');
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        if (listService.docType === constants.DOC_TYPE_REPORT) {
            $('#themeReset').html('Use Report Theme');
        }

        this.delegateEvents();
        return this;
    }


}

export default StyleTextView;
